import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	updated_at
	name
	active
	department_count
	
	translations {
		${FieldsTranslation}
	}
`;
